import { render, staticRenderFns } from "./DispatchItems.vue?vue&type=template&id=24aae50e&scoped=true&"
import script from "./DispatchItems.vue?vue&type=script&lang=js&"
export * from "./DispatchItems.vue?vue&type=script&lang=js&"
import style0 from "./DispatchItems.vue?vue&type=style&index=0&id=24aae50e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aae50e",
  null
  
)

export default component.exports